module.exports = __webpack_public_path__ + "img/Phone.e9f599f7.svg";